import { render, staticRenderFns } from "./overhaulDetail.vue?vue&type=template&id=6cf7b0d2&scoped=true"
import script from "./overhaulDetail.vue?vue&type=script&lang=js"
export * from "./overhaulDetail.vue?vue&type=script&lang=js"
import style0 from "./overhaulDetail.vue?vue&type=style&index=0&id=6cf7b0d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cf7b0d2",
  null
  
)

export default component.exports